export default __webpack_public_path__ + "static/media/hybrid-outlined.54854e26.svg";